import { createContext, useContext, useState } from 'react';

const UserContext = createContext(null);

function UserProvider({ children }) {
	const [user, setUser] = useState();
	const [isAuthPending, setIsAuthPending] = useState();
	const [refreshBalance, setRefreshBalance] = useState(0);
  const [transferBalance, setTransferBalance] = useState({});

	return (
		<UserContext.Provider value={{
			user,
			setUser,
			isAuthPending,
			setIsAuthPending,
			refreshBalance,
			setRefreshBalance,
			transferBalance,
			setTransferBalance,
		}}>
			{children}
		</UserContext.Provider>
	);
}

export const useUser = () => useContext(UserContext);

export default UserProvider;
